import { useEffect, useState } from "react";
import DashboardChart from "./DashboardChart";

export default function ChartBox({ fetchData }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData().then(setData);
  }, [fetchData]);

  return (
    <div className="box">
      <DashboardChart data={data} />
    </div>
  );
}